import { render } from "./statelist.vue?vue&type=template&id=83e12ccc"
import script from "./statelist.vue?vue&type=script&lang=js"
export * from "./statelist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__